export const pt = {
  "nav.check_booking": "Verificar Reserva",
  "nav.admin": "Admin",
  "nav.book_now": "Reservar Agora",
  "nav.driver": "Motorista",
  "hero.badge": "Transporte para Estudantes J1",
  "hero.title": "Easy Transportation",
  "hero.subtitle": "Seu Transporte de Confiança de Chicago para Wisconsin",
  "hero.description": "Transporte seguro, confiável e acessível para estudantes com visto J1. Reserve sua viagem hoje!",
  "hero.book_trip": "Reserve Sua Viagem",
  "hero.check_status": "Verificar Status da Reserva",
  "pricing.title": "Preços de Transporte",
  "pricing.subtitle": "Todos os preços em USD",
  "pricing.ohare_mke": "Embarque (O'Hare / Milwaukee)",
  "pricing.midway": "Embarque (Midway)",
  "pricing.madison": "Madison para Wisconsin Dells",
  "pricing.return": "Desconto para Retorno",
  "pricing.shared": "Viagem Compartilhada",
  "pricing.private": "Viagem Privada",
  "pricing.per_person": "por pessoa",
  "pricing.after_deposit": "com depósito de $20",
  "pricing.without_deposit": "sem depósito",
  "pricing.flat_rate": "taxa fixa",
  "pricing.per_suitcase": "Por mala",
  "pricing.carry_on": "Bagagem de mão",
  "pricing.free": "GRÁTIS",
  "pricing.with_shipping": "Retorno + envio conosco",
  "pricing.special_deal": "Oferta Especial!",
  "pricing.midway_contact": "Entre em contato para preços do Midway (MDW)",
  "pricing.waterpark_note": "Os preços podem variar para Three Bears Water Park ou outros destinos.",
  "pricing.contact_us": "Entre em contato",
  "pricing.guidelines_title": "Como Funcionam Nossos Preços",
  "pricing.guidelines_deposit": "Um depósito de $20 por pessoa garante sua reserva. O saldo restante é pago no dia da viagem.",
  "pricing.guidelines_shared": "2 ou mais passageiros viajando no mesmo dia para o mesmo aeroporto recebem a tarifa compartilhada.",
  "pricing.guidelines_solo": "Passageiros sozinhos (único passageiro naquele dia) podem ter uma tarifa ligeiramente mais alta.",
  "pricing.guidelines_suitcase": "1 mala incluída grátis em viagens de retorno. Cada mala adicional custa $5.",
  "pricing.guidelines_payment": "Aceitamos pagamentos com Cartão, Dinheiro e Zelle.",
  "requirements.title": "Requisitos de Reserva",
  "requirements.pickup": "Oferecemos coletas duas vezes em 24 horas, salvo notificação prévia. Planeje e reserve com antecedência!",
  "requirements.deposit": "É necessário um depósito não reembolsável de $3.200 JMD (ou $20 USD) antes de ser adicionado ao cronograma.",
  "requirements.seamless": "Garanta seu lugar fazendo seu depósito com antecedência para evitar atrasos.",
  "requirements.final_payment": "O saldo restante deve ser pago antes de entrar no veículo.",
  "special.title": "Destino Não Listado?",
  "special.description": "Oferecemos viagens especiais para destinos fora de nossas rotas regulares. Entre em contato para um orçamento!",
  "special.call": "Ligar",
  "special.whatsapp": "WhatsApp",
  "features.title": "Por Que Escolher Easy Transportation?",
  "features.subtitle": "Confiável por milhares de estudantes J1 todos os verões",
  "features.easy_booking": "Reserva Fácil",
  "features.easy_booking_desc": "Apenas depósito de $3.200 JMD ($20 USD) necessário. Pague por transferência, cartão, PayPal ou Zelle.",
  "features.safe": "Seguro e Confiável",
  "features.safe_desc": "Motoristas profissionais, veículos confortáveis e suporte 24/7 para estudantes J1.",
  "features.flexible": "Horário Flexível",
  "features.flexible_desc": "Reserve viagens de chegada e retorno. Primeira mala grátis nos retornos!",
  "video.badge": "Veja-nos em Ação",
  "video.title": "Sua Jornada Começa Aqui",
  "video.subtitle": "Assista estudantes J1 da Jamaica e República Dominicana começarem sua aventura",
  "video.book_now": "Reserve Sua Viagem Agora",
  "booking.title": "Reserve Sua Viagem",
  "booking.step": "Passo",
  "booking.of": "de",
  "booking.trip_type": "Tipo de Viagem",
  "booking.arrival": "Chegada (Busca no Aeroporto)",
  "booking.return": "Retorno (Para o Aeroporto)",
  "booking.ride_type": "Tipo de Serviço",
  "booking.shared_ride": "Viagem Compartilhada",
  "booking.shared_desc": "Compartilhe com outros passageiros na mesma rota",
  "booking.private_ride": "Viagem Privada",
  "booking.private_desc": "Veículo exclusivo só para você",
  "booking.pickup_location": "Aeroporto de Embarque",
  "booking.select_airport": "Selecionar Aeroporto",
  "booking.travel_date": "Data da Viagem",
  "booking.travel_time": "Hora de Chegada Estimada",
  "booking.departure_time": "Hora de Partida",
  "booking.flight_number": "Número do Voo",
  "booking.airline": "Companhia Aérea",
  "booking.terminal": "Terminal de Chegada",
  "booking.full_name": "Nome Completo",
  "booking.whatsapp": "Número de WhatsApp",
  "booking.email": "Endereço de Email",
  "booking.housing": "Unidade de Moradia",
  "booking.select_housing": "Selecionar Moradia",
  "booking.custom_address": "Inserir Endereço Personalizado",
  "booking.num_passengers": "Número de Passageiros",
  "booking.suitcases": "Total de Malas",
  "booking.shipping": "Usar T&M Courier Services?",
  "booking.payment": "Método de Pagamento",
  "booking.referral": "Código de Indicação",
  "booking.next": "Próximo",
  "booking.previous": "Anterior",
  "booking.submit": "Completar Reserva",
  "booking.processing": "Processando...",
  "booking.start_over": "Recomeçar",
  "booking.first_time": "Primeira Viagem",
  "booking.returning": "Cliente Retornando",
  "booking.confirmation_number": "Número de Confirmação",
  "pricing_summary.title": "Resumo de Preços",
  "pricing_summary.trip_price": "Preço da Viagem",
  "pricing_summary.luggage_fee": "Taxa de Bagagem",
  "pricing_summary.deposit": "Depósito",
  "pricing_summary.per_person": "por pessoa",
  "pricing_summary.discount": "Desconto de Indicação",
  "pricing_summary.total_now": "Total a Pagar Agora",
  "pricing_summary.balance": "Saldo Restante",
  "success.title": "Reserva Confirmada!",
  "success.confirmation": "Número de Confirmação",
  "success.details": "Detalhes da Reserva",
  "success.whatsapp_optin": "Receber atualizações pelo WhatsApp",
  "success.home": "Voltar ao Início",
  "driver.title": "Painel do Motorista",
  "driver.login": "Acesso do Motorista",
  "driver.phone": "Número de Telefone",
  "driver.pin": "Código PIN",
  "driver.sign_in": "Entrar",
  "driver.trips_today": "Viagens de Hoje",
  "driver.upcoming": "Próximas Viagens",
  "driver.passengers": "passageiros",
  "driver.suitcases": "malas",
  "driver.navigate": "Navegar para Embarque",
  "driver.contact": "Contatar Passageiro",
  "driver.complete": "Completar Viagem",
  "driver.logout": "Sair",
  "driver.no_trips": "Nenhuma viagem agendada",
  "common.loading": "Carregando...",
  "common.error": "Algo deu errado",
  "common.save": "Salvar",
  "common.cancel": "Cancelar",
  "common.close": "Fechar",
  "common.details": "Detalhes",
  "common.status": "Status",
  "common.date": "Data",
  "common.time": "Hora",
  "common.price": "Preço",
  "common.passenger": "Passageiro",
  "common.passengers": "Passageiros",
};
